import { CONFIGURATION, TEXT } from 'Config/Paths';
import { CustomTextConfiguration } from 'Models/CustomTextConfiguration';
import { ResponseModel } from 'Models/ResponseModel';
import { restApiGet, restApiPost } from 'RestApiConnector';

import { CustomTextConfigurationApi } from './CustomTextConfigurationApi';

export class AWSCustomTextConfigurationApi implements CustomTextConfigurationApi {
    getCustomizedText = (): Promise<ResponseModel<CustomTextConfiguration>> => {
        return restApiGet(`/${CONFIGURATION}/${TEXT}`, {});
    };

    setCustomizedText = (configuration: CustomTextConfiguration): Promise<ResponseModel<void>> => {
        return restApiPost(`/${CONFIGURATION}/${TEXT}`, configuration);
    };
}
